// TERAISM のカジュアルゲーム 共通の処理（2026-10-11〜）。各ゲームの game.js が自分の設定（例：const CAPFIT = {...}）を作って boot(CAPFIT) を呼ぶ（GAME という名前は共通側が使うので使わない）。
// 元のファイルは teraism-scripts の ゲーム制作/カジュアル（build.py で1枚の HTML に書き出す）
const $ = (id) => document.getElementById(id);
const TAU = Math.PI * 2;
const C = { bg: '#E3F2E6', leaf: '#1FA35C', deep: '#157A44', ink: '#1E4A35', spark: '#F4B400', salmon: '#F07F6B', line: '#CFE8D6', white: '#FFFFFF' };
const rand = (a, b) => a + Math.random() * (b - a);
const clamp = (v, a, b) => Math.max(a, Math.min(b, v));

// ---------- 商品データ（ストアではページを開いた時点のもの、公開ページ版は控え） ----------
const SHOPCFG = window.TERAISM_CASUAL || null;
const SNAP = SHOPCFG ? SHOPCFG.data : /*DATA*/null/*END*/;
const ITEMS = (SNAP && SNAP.items) || {};
const STORE_URL = SHOPCFG ? '/products/' : 'https://shop.light-technical.com/products/';
const yen = (n) => '¥' + n.toLocaleString('ja-JP');
const esc = (t) => String(t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

// ---------- 画面 ----------
const cv = $('cv'), ctx = cv.getContext('2d');
let W = 1, H = 1, DPR = 1;
function resize(){
  W = innerWidth; H = innerHeight;
  if (!W || !H) return;
  DPR = Math.min(window.devicePixelRatio || 1, 2);
  cv.width = Math.round(W * DPR); cv.height = Math.round(H * DPR);
}
addEventListener('resize', resize);

// ---------- 効果音（その場で合成） ----------
let AC = null, MASTER = null, NOISE = null, MUSIC = null;
let soundOn = (() => { try { return localStorage.getItem('teraism-casual-sound') !== 'off'; } catch(e){ return true; } })();
function audioInit(){
  try {
    if (!AC){
      AC = new (window.AudioContext || window.webkitAudioContext)();
      const comp = AC.createDynamicsCompressor(); comp.threshold.value = -18; comp.ratio.value = 6;
      MASTER = AC.createGain(); MASTER.gain.value = soundOn ? 0.6 : 0;
      MASTER.connect(comp).connect(AC.destination);
      MUSIC = AC.createGain(); MUSIC.gain.value = soundOn ? 1 : 0; MUSIC.connect(AC.destination);   // 曲は効果音の圧縮を通さない
      NOISE = AC.createBuffer(1, AC.sampleRate, AC.sampleRate);
      const d = NOISE.getChannelData(0); for (let i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
    }
    if (AC.state === 'suspended') AC.resume();
  } catch(e){ AC = null; }
}
function tone(f1, f2, dur, type, vol, when = 0){
  const t = AC.currentTime + when, o = AC.createOscillator(), g = AC.createGain();
  o.type = type; o.frequency.setValueAtTime(f1, t); o.frequency.exponentialRampToValueAtTime(Math.max(20, f2), t + dur);
  g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(vol, t + 0.008); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.connect(g).connect(MASTER); o.start(t); o.stop(t + dur + 0.02);
}
function hiss(dur, vol, f1, f2, ftype = 'bandpass', q = 1, when = 0){
  const t = AC.currentTime + when, src = AC.createBufferSource(), f = AC.createBiquadFilter(), g = AC.createGain();
  src.buffer = NOISE; f.type = ftype; f.Q.value = q;
  f.frequency.setValueAtTime(f1, t); f.frequency.exponentialRampToValueAtTime(Math.max(30, f2), t + dur);
  g.gain.setValueAtTime(vol, t); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  src.connect(f).connect(g).connect(MASTER); src.start(t, Math.random() * 0.5); src.stop(t + dur + 0.02);
}
const NOTE = (n) => 440 * Math.pow(2, (n - 69) / 12);
const SFX = {
  click(){ tone(900, 1200, 0.035, 'triangle', 0.035); },
  clear(){ [72, 76, 79, 84].forEach((n, i) => tone(NOTE(n), NOTE(n), 0.14, 'square', 0.045, i * 0.07)); tone(NOTE(91), NOTE(91), 0.3, 'sine', 0.05, 0.28); },
  over(){ [67, 64, 60, 55].forEach((n, i) => tone(NOTE(n), NOTE(n) * 0.97, 0.22, 'triangle', 0.07, i * 0.18)); },
  best(){ [72, 76, 79, 84, 88].forEach((n, i) => tone(NOTE(n), NOTE(n), 0.14, 'square', 0.045, i * 0.07)); },
};
function sfx(name, arg){ if (!AC || !soundOn || !SFX[name]) return; try { SFX[name](arg); } catch(e){} }
function setSound(on){
  soundOn = on;
  try { localStorage.setItem('teraism-casual-sound', on ? 'on' : 'off'); } catch(e){}
  if (MASTER) MASTER.gain.value = on ? 0.6 : 0;
  if (MUSIC) MUSIC.gain.value = on ? 1 : 0;
  for (const id of ['soundBtn', 'soundBtnTitle']){ const b = $(id); b.textContent = on ? '音 ON' : '音 OFF'; b.setAttribute('aria-pressed', on); }
}

// ---------- 曲（音楽生成AIの mp3）：ゲームの設定 music: { title: {src, loopStart, loopEnd, vol}, play: {...} } ----------
// 生成AIの曲は最後がフェードアウトなので、make_loop.py で戻り位置を測って切った mp3 を使い、Web Audio で loopStart〜loopEnd を繰り返す（最初だけ前奏）。
// src は snd('名前')：公開ページ版は build.py が SND_SRC に data: で埋め込む。ストア版はテーマの assets の URL を SND_SRC に入れる
const snd = (n) => n;
const MUSIC_BUF = {};
let musicCur = null;
function musicLoad(m){
  if (!MUSIC_BUF[m.src]){
    const url = (typeof SND_SRC !== 'undefined' && SND_SRC[m.src]) || '';
    const bytes = url.startsWith('data:')
      ? Promise.resolve(Uint8Array.from(atob(url.slice(url.indexOf(',') + 1)), c => c.charCodeAt(0)).buffer)
      : fetch(url).then(r => r.arrayBuffer());
    MUSIC_BUF[m.src] = bytes.then(b => new Promise((ok, ng) => AC.decodeAudioData(b, ok, ng)));
  }
  return MUSIC_BUF[m.src];
}
function musicWant(key, restart){
  if (!AC || !GAME || !GAME.music) return;
  if (musicCur && musicCur.key === key && !restart) return;
  musicStop(0.4);
  const m = GAME.music[key]; if (!m) return;
  const tok = { key }; musicCur = tok;
  musicLoad(m).then(buf => {
    if (musicCur !== tok) return;
    const src = AC.createBufferSource(), g = AC.createGain(), t = AC.currentTime;
    src.buffer = buf; src.loop = true; src.loopStart = m.loopStart; src.loopEnd = Math.min(m.loopEnd, buf.duration);
    g.gain.setValueAtTime(0.0001, t); g.gain.linearRampToValueAtTime(m.vol || 0.3, t + 0.25);
    src.connect(g).connect(MUSIC); src.start(t);
    tok.src = src; tok.g = g; tok.vol = m.vol || 0.3;
  }).catch(() => {});
}
function musicStop(fade = 0.5){
  const c = musicCur; musicCur = null;
  if (!c || !c.src) return;
  const t = AC.currentTime;
  c.g.gain.cancelScheduledValues(t); c.g.gain.setValueAtTime(c.g.gain.value, t); c.g.gain.linearRampToValueAtTime(0.0001, t + fade);
  c.src.stop(t + fade + 0.05);
}
// ジングル（1回だけ鳴らす短い曲）：鳴っている間は曲を小さくする。素材が無い・読めないときは合成音（fallback）
const hasSnd = (src) => typeof SND_SRC !== 'undefined' && !!SND_SRC[src];
function jingle(src, vol = 0.5, fallback){
  if (!AC || !soundOn) return;
  if (!hasSnd(src)){ if (fallback) sfx(fallback); return; }
  musicLoad({ src }).then(buf => {
    const s = AC.createBufferSource(), g = AC.createGain();
    s.buffer = buf; g.gain.value = vol; s.connect(g).connect(MUSIC); s.start();
    musicDuck(buf.duration);
  }).catch(() => { if (fallback) sfx(fallback); });
}
function musicDuck(sec){
  const c = musicCur; if (!c || !c.g) return;
  const t = AC.currentTime, v = c.vol;
  c.g.gain.cancelScheduledValues(t); c.g.gain.setValueAtTime(c.g.gain.value, t);
  c.g.gain.linearRampToValueAtTime(v * 0.25, t + 0.12); c.g.gain.setValueAtTime(v * 0.25, t + Math.max(0.2, sec - 0.4)); c.g.gain.linearRampToValueAtTime(v, t + sec + 0.4);
}
// タブを裏に回したら止める
document.addEventListener('visibilitychange', () => { if (!AC) return; if (document.hidden) AC.suspend(); else AC.resume(); });

// ---------- 演出：お知らせ・はじける粒・画面の揺れ・浮かぶ文字 ----------
let toastT = 0;
function toast(s){ const t = $('toast'); t.textContent = s; t.hidden = false; t.classList.remove('pop'); void t.offsetWidth; t.classList.add('pop'); toastT = 1.6; }
const FX = { parts: [], texts: [], shake: 0 };
function burst(x, y, col, n = 14, sp = 260){
  for (let i = 0; i < n; i++){ const a = rand(0, TAU), v = rand(sp * 0.3, sp); FX.parts.push({ x, y, vx: Math.cos(a) * v, vy: Math.sin(a) * v, life: rand(0.35, 0.7), max: 0.7, r: rand(2, 5), col }); }
}
function floatText(x, y, s, col = C.deep){ FX.texts.push({ x, y, s, col, life: 0.9 }); }
function shake(v = 10){ FX.shake = Math.max(FX.shake, v); }
function fxUpdate(dt){
  for (let i = FX.parts.length - 1; i >= 0; i--){ const p = FX.parts[i]; p.life -= dt; p.x += p.vx * dt; p.y += p.vy * dt; p.vy += 600 * dt; if (p.life <= 0) FX.parts.splice(i, 1); }
  for (let i = FX.texts.length - 1; i >= 0; i--){ const t = FX.texts[i]; t.life -= dt; t.y -= 50 * dt; if (t.life <= 0) FX.texts.splice(i, 1); }
  FX.shake = Math.max(0, FX.shake - dt * 40);
}
function fxDraw(){
  for (const p of FX.parts){ ctx.globalAlpha = clamp(p.life / p.max, 0, 1); ctx.fillStyle = p.col; ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, TAU); ctx.fill(); }
  ctx.globalAlpha = 1;
  ctx.textAlign = 'center'; ctx.font = "900 22px 'Zen Maru Gothic', sans-serif";
  for (const t of FX.texts){ ctx.globalAlpha = clamp(t.life / 0.5, 0, 1); ctx.lineWidth = 5; ctx.strokeStyle = '#fff'; ctx.strokeText(t.s, t.x, t.y); ctx.fillStyle = t.col; ctx.fillText(t.s, t.x, t.y); }
  ctx.globalAlpha = 1;
}
// 角の丸い四角
function rr(x, y, w, h, r){ ctx.beginPath(); if (ctx.roundRect) ctx.roundRect(x, y, w, h, r); else ctx.rect(x, y, w, h); }

// ---------- 最高記録（この端末だけ） ----------
// 難易度があるゲーム（設定 levels: [{ id, name }, …]）は、最高記録を難易度ごとに分ける
const bestKey = (id) => 'teraism-casual-best-' + id + (LEVEL ? '-' + LEVEL : '');
function loadBest(id){ try { return Number(localStorage.getItem(bestKey(id))) || 0; } catch(e){ return 0; } }
function saveBest(id, v){ try { localStorage.setItem(bestKey(id), String(v)); } catch(e){} }

// ---------- ランキング（ゲームの設定 ranking: true）：デイリー・ウィークリー・マンスリー・年間 ----------
// ストア版：ページの Liquid が window.TERAISM_CASUAL.rankApi（例 '/apps/teraism/game/casual'）を渡すと、サーバーに記録を送り、順位を読む。
//   POST {rankApi}/start { game, level } → { ok, token }（遊び始めに1回）
//   POST {rankApi}/score { token, game, level, score, ...GAME.rankExtra() } → { ok }（終わりに1回。gate は meters・stage を足す）
//   GET  {rankApi}/rank?game=&level=&period=day|week|month|year&token= → { top: [{ name, score, me }], me: { rank, score } | null }（token でゲストも自分の記録が分かる）
//   GET  {rankApi}/pref → { loggedIn, hideName, nickname }、POST {rankApi}/pref { hideName } … ログインしている人だけ「ランキングに名前を出さない」（出すと「匿名」）
//   名前はサーバー側で決める（ログインしているお客様は事例投稿のプロフィールのニックネーム、未設定・ログインなしは「ゲスト」）。設計は ゲーム制作/カジュアル/ランキング設計.md
// 公開ページ版（サーバーなし）：この端末の記録だけで同じ画面を出す（試作の確かめ用）
const RANK_API = (SHOPCFG && SHOPCFG.rankApi) || '';
const PERIOD_NAME = { day: 'デイリー', week: 'ウィークリー', month: 'マンスリー', year: '年間' };
let rankPeriod = 'day', lastRec = null, rankToken = null, rankLastToken = null;
async function rankStart(){
  rankToken = null;
  if (!RANK_API || !GAME.ranking) return;
  try { const r = await (await fetch(RANK_API + '/start', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ game: GAME.id, level: LEVEL || '' }), credentials: 'same-origin' })).json(); rankToken = r && r.token || null; } catch(e){}
}
// 期間の始まり（日本時間）：日＝その日、週＝月曜、月＝1日、年＝1月1日
function periodStart(p, now = Date.now()){
  const j = new Date(now + 9 * 3600e3); const y = j.getUTCFullYear(); let m = j.getUTCMonth(), d = j.getUTCDate();
  if (p === 'week') d -= (j.getUTCDay() + 6) % 7;
  if (p === 'month') d = 1;
  if (p === 'year'){ m = 0; d = 1; }
  return Date.UTC(y, m, d) - 9 * 3600e3;
}
const localRankKey = () => 'teraism-casual-rank-' + GAME.id + (LEVEL ? '-' + LEVEL : '');
function localRankList(){ try { return JSON.parse(localStorage.getItem(localRankKey()) || '[]'); } catch(e){ return []; } }
function localRankAdd(sc){
  const rec = { s: sc, t: Date.now() };
  const a = localRankList().concat(rec).filter(r => r.t >= periodStart('year')).sort((x, y) => y.s - x.s).slice(0, 200);
  try { localStorage.setItem(localRankKey(), JSON.stringify(a)); } catch(e){}
  return rec;
}
function localRankGet(p, mine){
  const from = periodStart(p), list = localRankList().filter(r => r.t >= from).sort((x, y) => y.s - x.s);
  const same = (r) => mine && r.t === mine.t && r.s === mine.s, i = list.findIndex(same);
  return { top: list.slice(0, 10).map(r => ({ name: 'あなた', score: r.s, me: same(r) })), me: i >= 0 ? { rank: i + 1, score: list[i].s } : null, local: true };
}
async function rankSubmit(sc){
  if (!RANK_API){ lastRec = localRankAdd(sc); return; }
  if (!rankToken) return;
  const extra = GAME.rankExtra ? GAME.rankExtra() : {};
  try { await fetch(RANK_API + '/score', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(Object.assign({ token: rankToken, game: GAME.id, level: LEVEL || '', score: sc }, extra)), credentials: 'same-origin' }); } catch(e){}
  rankLastToken = rankToken; rankToken = null;
}
async function rankShow(p){
  rankPeriod = p;
  for (const b of $('rankTabs').children) b.setAttribute('aria-selected', b.dataset.p === p);
  const L = $('rankList'); L.innerHTML = '<li class="empty">読み込み中…</li>';
  let r = null;
  if (RANK_API){
    try { r = await (await fetch(RANK_API + '/rank?game=' + encodeURIComponent(GAME.id) + '&level=' + encodeURIComponent(LEVEL || '') + '&period=' + p + (rankLastToken ? '&token=' + encodeURIComponent(rankLastToken) : ''), { credentials: 'same-origin' })).json(); } catch(e){ r = null; }
  } else r = localRankGet(p, lastRec);
  if (rankPeriod !== p) return;
  if (!r){ L.innerHTML = '<li class="empty">ランキングを読み込めませんでした</li>'; return; }
  const unit = esc(GAME.unit || ''), num = (v) => Number(v).toLocaleString('ja-JP');
  const rows = (r.top || []).map((x, i) => `<li class="${x.me ? 'me' : ''}"><span class="rn">${i + 1}</span><span class="nm">${esc(x.name || 'ゲスト')}</span><span class="sc">${num(x.score)}${unit}</span></li>`);
  if (r.me && r.me.rank > 10) rows.push(`<li class="me"><span class="rn">${r.me.rank}</span><span class="nm">あなた</span><span class="sc">${num(r.me.score)}${unit}</span></li>`);
  L.innerHTML = rows.join('') || '<li class="empty">まだ記録がありません</li>';
  $('rankNote').textContent = (LEVEL ? levelName() + 'の' : '') + PERIOD_NAME[p] + 'ランキング' + (r.local ? '（試作のため、この端末の記録だけを表示しています）' : '');
}
// 名前を出さない設定（ログインしている人だけ）。ニックネームは事例投稿のプロフィールのもの
async function rankPref(){
  const box = $('rankPref'); box.hidden = true;
  if (!RANK_API || !(SHOPCFG && SHOPCFG.loggedIn)) return;
  let pf = null; try { pf = await (await fetch(RANK_API + '/pref', { credentials: 'same-origin' })).json(); } catch(e){}
  if (!pf || !pf.loggedIn) return;
  box.innerHTML = `<label><input type="checkbox" id="hideName" ${pf.hideName ? 'checked' : ''}>ランキングに名前を出さない（「匿名」と出ます）</label>`
    + `<small>${pf.nickname ? 'いまのニックネーム：' + esc(pf.nickname) : 'ニックネームが未設定のため「ゲスト」と出ます'}（ニックネームは事例投稿のプロフィールで変えられます）</small>`;
  box.hidden = false;
  $('hideName').onchange = async (e) => {
    const on = e.target.checked; e.target.disabled = true;
    try { await fetch(RANK_API + '/pref', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ hideName: on }), credentials: 'same-origin' }); } catch(err){}
    e.target.disabled = false; rankShow(rankPeriod);
  };
}

// ---------- 流れ：タイトル → 遊ぶ → 結果 ----------
let GAME = null, state = 'title', score = 0, LEVEL = null;
const levelName = () => { const l = GAME && GAME.levels && GAME.levels.find(v => v.id === LEVEL); return l ? l.name : ''; };
function show(id){ for (const o of ['ovTitle', 'ovResult']) $(o).hidden = o !== id; }
function setScore(v){ score = v; $('score').textContent = v; }
function start(){
  audioInit(); sfx('click');
  FX.parts.length = 0; FX.texts.length = 0; FX.shake = 0;
  setScore(0); GAME.start(); musicWant('play', true); rankStart();
  $('hud').hidden = false; show(null); state = 'play';
}
// 終わり：note は結果に出す一言、used は結果に出す商品（handle の配列）
function gameOver(note){
  if (state !== 'play') return;
  state = 'over'; musicStop(0.8);
  setTimeout(() => {
    const best = loadBest(GAME.id), isBest = score > best;
    if (isBest) saveBest(GAME.id, score);
    $('resTitle').textContent = isBest && score > 0 ? '最高記録！' : 'おしい！';
    $('resScore').textContent = score; $('resLbl').textContent = (GAME.unit || '') + (LEVEL ? '（' + levelName() + '）' : '');
    $('resNote').textContent = (note || '') + (isBest ? '' : '　最高 ' + Math.max(best, score) + (GAME.unit || ''));
    const used = (GAME.usedProducts ? GAME.usedProducts() : GAME.products).filter(h => ITEMS[h] && ITEMS[h].ok);
    $('resProdH').hidden = !used.length;
    $('resProds').innerHTML = used.map(h => { const it = ITEMS[h]; return `<li><a href="${STORE_URL + encodeURIComponent(h)}" target="_blank" rel="noopener">${it.img ? `<span class="ph"><img src="${it.img}" alt="" width="320" height="320"></span>` : ''}<span><b>${esc(it.t)}</b><small>${yen(it.price)}（税込）</small></span><i>見る</i></a></li>`; }).join('');
    if (GAME.ranking){ $('rank').hidden = false; rankSubmit(score).then(() => rankShow(rankPeriod)); rankPref(); }
    const jk = isBest && score > 0 ? 'best' : 'over';   // ゲームの設定 jingles: { over, best } に曲があればそれを、無ければ合成音
    if (GAME.jingles && GAME.jingles[jk]) jingle(GAME.jingles[jk], 0.55, jk); else sfx(jk);
    $('hud').hidden = true; show('ovResult');
  }, 700);
}
function toTitle(){
  state = 'title'; $('hud').hidden = true;
  const b = loadBest(GAME.id); $('titleBest').textContent = b ? '最高記録 ' + b + (GAME.unit || '') + (LEVEL ? '（' + levelName() + '）' : '') : '';
  if (GAME.title) GAME.title();
  show('ovTitle'); musicWant('title');
}

// ---------- 起動 ----------
function boot(game){
  GAME = game;
  document.title = game.name;
  $('titleLogo').textContent = game.name; $('titleLogo').classList.toggle('long', game.name.length > 6); $('ovTitle').classList.toggle('art', !!game.titleArt); $('titleSub').textContent = game.sub;   // titleArt：タイトル画があるゲームは、白い枠を下に寄せて絵を見せる
  $('titleHow').innerHTML = game.how.map(s => `<li>${s}</li>`).join('');
  $('scoreLbl').textContent = game.unit || '';
  Object.assign(SFX, game.sfx || {});
  // 難易度のボタン（選んだものはこの端末に覚えておく）
  if (game.levels){
    try { LEVEL = localStorage.getItem('teraism-casual-level-' + game.id); } catch(e){}
    if (!game.levels.some(l => l.id === LEVEL)) LEVEL = (game.levels[1] || game.levels[0]).id;
    const box = $('levels'); box.hidden = false;
    box.innerHTML = game.levels.map(l => `<button type="button" data-lv="${l.id}" aria-pressed="${l.id === LEVEL}">${esc(l.name)}</button>`).join('');
    box.onclick = (e) => {
      const b = e.target.closest('button'); if (!b) return;
      LEVEL = b.dataset.lv; try { localStorage.setItem('teraism-casual-level-' + game.id, LEVEL); } catch(err){}
      for (const x of box.children) x.setAttribute('aria-pressed', x.dataset.lv === LEVEL);
      audioInit(); sfx('click'); toTitle();
    };
  }
  // 操作：画面を押す・離す（スペースキーでも）
  const down = (e) => { audioInit(); if (state === 'play' && GAME.press) GAME.press(e); };
  const up = (e) => { if (state === 'play' && GAME.release) GAME.release(e); };
  cv.addEventListener('pointerdown', (e) => { e.preventDefault(); down(e); });
  addEventListener('pointerup', up); addEventListener('pointercancel', up);
  addEventListener('keydown', (e) => { if (e.code === 'Space' && !e.repeat){ e.preventDefault(); if (state === 'play') down(e); else if (state === 'title') start(); } });
  addEventListener('keyup', (e) => { if (e.code === 'Space') up(e); });
  $('startBtn').onclick = start; $('againBtn').onclick = start;
  $('titleBtn').onclick = () => { sfx('click'); toTitle(); };
  for (const id of ['soundBtn', 'soundBtnTitle']) $(id).onclick = () => { audioInit(); setSound(!soundOn); sfx('click'); };
  if (game.titleArt){   // タイトル画のあるゲーム：遊び方はボタンで開く
    const hb = $('howBtn'), pn = hb.closest('.panel'); hb.hidden = false;
    hb.onclick = () => { const on = !pn.classList.contains('showhow'); pn.classList.toggle('showhow', on); hb.setAttribute('aria-expanded', on); sfx('click'); };
  }
  if (game.ranking){   // ランキングの期間の切り替えと、遊ぶ前の注意書き
    $('rankTabs').onclick = (e) => { const b = e.target.closest('button'); if (b){ sfx('click'); rankShow(b.dataset.p); } };
    $('rankInfo').hidden = false;
    $('rankInfo').textContent = 'ランキング（デイリー・ウィークリー・マンスリー・年間）に記録が載ります。ストアにログインしている方は、事例投稿のプロフィールのニックネームで載ります（未設定・ログインしていない方は「ゲスト」）。';
  }
  // ブラウザは画面に触れるまで音を出せない：最初のタップでタイトルの曲を流す
  for (const ev of ['pointerdown', 'keydown']) addEventListener(ev, () => { audioInit(); if (state === 'title') musicWant('title'); }, { capture: true });
  setSound(soundOn); resize(); toTitle();
  let last = performance.now();
  const frame = (now) => {
    requestAnimationFrame(frame);
    const dt = Math.min(0.05, (now - last) / 1000); last = now;
    if (innerWidth !== W || innerHeight !== H) resize();
    if (!W || !H) return;
    if (state === 'play' || state === 'over') GAME.update(dt, state === 'play');
    else if (GAME.idle) GAME.idle(dt);
    fxUpdate(dt);
    if (toastT > 0){ toastT -= dt; if (toastT <= 0) $('toast').hidden = true; }
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    ctx.fillStyle = C.bg; ctx.fillRect(0, 0, W, H);
    const sx = FX.shake ? rand(-FX.shake, FX.shake) : 0, sy = FX.shake ? rand(-FX.shake, FX.shake) : 0;
    ctx.translate(sx, sy);
    GAME.draw();
    fxDraw();
  };
  requestAnimationFrame(frame);
}


// 駐車場：ぎっしり止まった車を、スワイプで1台ずつ外の道路へ出す（2026-10-12）
// 車の向きは上下左右。スワイプした向き（またはタップ）に、向きの前か後ろへまっすぐ走る。道があいていれば外へ出ていき、車がいればぶつかって元の場所へ戻る。
// 配置は「出せる車から順に出す」探索で必ず全部出せることを確かめてから使う（ぶつかっても車は元の場所へ戻るので、どの順番で試しても解けなくならない）
// 車の絵は真上から見た形をプログラムで描く。屋根や荷台に載せる TERAISM 商品は実物の写真を丸く切り抜いたもの
const PARK_ITEMS = [
  'teraism-ec-13-usb', 'teraism-ec-13sp-usb', 'teraism-ec-15b2-usb-usb', 'teraism-ec-17', 'teraism-ex-01sp', 'teraism-ex-02sp-1-pc',
  'teraism-ae-06sp-1-pc-ti-copper', 'teraism-ae-07sp', 'teraism-ae-08-1-sheet-b', 'teraism-ae-09-1-sheet', 'teraism-pf-84-1-sheet',
  'teraism-rp-01b-stealth-black-1-pc', 'teraism-fc-09-copper-1-pc', 'teraism-fc-13-copper-1-pc', 'teraism-eo-02mx-10g',
  'teraism-sb-01-20cm', 'teraism-do-01-copper-1m', 'teraism-bn-02-gold-4-pc-set', 'teraism-ta-03-4-pc-64-ti', 'teraism-fr-05-sp-ti',
  'teraism-ta-01-gunmetal-2', 'teraism-eb-15-52mm-76mm-1-pc', 'teraism-joy-copper-1-sheet', 'teraism-ec-06',
];
// 車の色（黒・濃い色は使わない）：main 車体、light 屋根、dark ふち
// 10/17 金の車と見分けるため、ふつうの車に黄色は使わない
const CAR_COLORS = [
  { main: '#F59A89', light: '#FBC4B8', dark: '#D9604C' },   // サーモンピンク
  { main: '#8FD0F0', light: '#C4E8F8', dark: '#4A9BC9' },   // 水色
  { main: '#F7E2A0', light: '#FFF4CF', dark: '#D1B25A' },   // クリーム
  { main: '#C9B6F2', light: '#E3D8F9', dark: '#8F78C9' },   // ラベンダー
  { main: '#7FD6A0', light: '#BDEBCF', dark: '#2FA066' },   // 明るい緑
  { main: '#FFC2D4', light: '#FFE0EA', dark: '#E07A9A' },   // ももいろ
];
// 10/17 依頼者「面白く仕上げて」：1面・2面は駐車場を小さくして早く終わる（序盤のテンポ）。coneFrom … 動かないコーンを置き始める面
// 難易度：cols×rows が駐車場の大きさ、fill が「マスの何割に車を置くか」（面ごとに df ずつ増えて fmax まで）、long が3マスの長い車の割合
const LV = {
  easy:   { cols: 5, rows: 6, fill: 0.46, df: 0.03,  fmax: 0.72, long0: 0.08, long1: 0.28, lives: 5, depth: 3, coneFrom: 4 },
  normal: { cols: 6, rows: 7, fill: 0.56, df: 0.035, fmax: 0.80, long0: 0.16, long1: 0.38, lives: 4, depth: 4, coneFrom: 3 },
  hard:   { cols: 6, rows: 8, fill: 0.64, df: 0.03,  fmax: 0.84, long0: 0.26, long1: 0.48, lives: 3, depth: 5, coneFrom: 2 },
};
const lvP = () => LV[LEVEL] || LV.normal;
const PK = { stage: 0, cols: 6, rows: 7, cars: [], lives: 3, maxLives: 3, bumps: 0, clearT: 0, t: 0, out: [], exited: 0, down: null, busy: 0, bag: [], img: {}, flash: 0, parade: [], word: null };
const PIN = 0.25;
const GOLD = { main: '#FFCF40', light: '#FFE79A', dark: '#C99700' };   // 金の車   // 車が現れる（ぽんと大きくなる）秒数

// ---------- 配置を作る ----------
const carCells = (c) => { const a = []; for (let i = 0; i < c.len; i++) a.push(c.ax === 'h' ? [c.c + i, c.r] : [c.c, c.r + i]); return a; };
// 出せる向きの調べ：occ は全マスの車の番号、self は自分。戻り値 { d: 進める数, hit: ぶつかる車 or null }（hit が null なら外まで道があいている）
function lane(occ, cols, rows, cars, car, s){
  let x = car.c, y = car.r;
  if (s > 0){ if (car.ax === 'h') x += car.len; else y += car.len; } else { if (car.ax === 'h') x -= 1; else y -= 1; }
  let d = 0;
  while (x >= 0 && y >= 0 && x < cols && y < rows){
    const o = occ[y * cols + x];
    if (o >= 0) return { d, hit: cars[o] };
    d++; if (car.ax === 'h') x += s; else y += s;
  }
  return { d, hit: null };
}
const occOf = (cols, rows, cars) => { const occ = new Array(cols * rows).fill(-1); cars.forEach((c, i) => { if (!c.gone && c.st !== 'exit') for (const [x, y] of carCells(c)) occ[y * cols + x] = i; }); return occ; };
// 「出せる車から順に出す」を全部の車でやってみる。段数（一斉に出せる順の回数）を返す。出せなければ -1
function peelDepth(cols, rows, cars){
  const t = cars.map(c => ({ ...c, gone: false }));
  let left = t.filter(c => !c.fixed).length, depth = 0;
  while (left > 0){
    const occ = occOf(cols, rows, t), freed = [];
    t.forEach((c, i) => { if (!c.gone && !c.fixed && (lane(occ, cols, rows, t, c, 1).hit === null || lane(occ, cols, rows, t, c, -1).hit === null)) freed.push(i); });
    if (!freed.length) return -1;
    for (const i of freed) t[i].gone = true;
    left -= freed.length; depth++;
  }
  return depth;
}
function layout(cols, rows, fill, longP, wantDepth, cones = 0){
  let best = null, bestScore = -1;
  for (let tr = 0; tr < 140; tr++){
    const cars = [], grid = new Array(cols * rows).fill(false);
    const target = Math.round(cols * rows * fill);
    let used = 0;
    for (let guard = 0; guard < 500 && used < target - 1; guard++){
      const len = Math.random() < longP ? 3 : 2, ax = Math.random() < 0.5 ? 'h' : 'v';
      const c = Math.floor(rand(0, cols - (ax === 'h' ? len - 1 : 0))), r = Math.floor(rand(0, rows - (ax === 'v' ? len - 1 : 0)));
      const car = { c, r, len, ax };
      const cells = carCells(car);
      if (cells.some(([x, y]) => grid[y * cols + x])) continue;
      for (const [x, y] of cells) grid[y * cols + x] = true;
      used += len;
      cars.push(car);
    }
    if (cars.length < 3) continue;
    // 動かないコーン（1マス）：あいているマスに置く。コーンはどの車にとっても壁になる
    const empty = []; for (let i = 0; i < cols * rows; i++) if (!grid[i]) empty.push(i);
    shuffleP(empty).slice(0, cones).forEach(i => cars.push({ c: i % cols, r: Math.floor(i / cols), len: 1, ax: 'h', fixed: true }));
    const dep = peelDepth(cols, rows, cars);
    if (dep < 0) continue;
    const occ = occOf(cols, rows, cars), free0 = cars.filter(c => !c.fixed && (lane(occ, cols, rows, cars, c, 1).hit === null || lane(occ, cols, rows, cars, c, -1).hit === null)).length;
    const sc = Math.min(dep, wantDepth) * 20 - free0 * 4 + cars.length;   // 段数が多く、最初に出せる車が少ない配置ほど歯ごたえがある
    if (sc > bestScore){ bestScore = sc; best = cars; if (dep >= wantDepth && free0 <= 3 && tr > 25) break; }
  }
  return best;
}
function newStage(){
  const L = lvP();
  PK.stage++;
  const small = PK.stage === 1 ? 2 : PK.stage === 2 ? 1 : 0;   // 1面は2行・1列、2面は1行小さい
  const colsN = L.cols - (small ? 1 : 0), rowsN = L.rows + (H / W > 1.9 ? 1 : 0) - small;
  const cones = PK.stage >= L.coneFrom ? Math.min(3, 1 + Math.floor((PK.stage - L.coneFrom) / 3)) : 0;
  PK.cols = colsN; PK.rows = rowsN; PK.hintT = 0; PK.chain = 0; PK.bumps = 0; PK.exited = 0; PK.clearT = 0; PK.out = []; PK.busy = 0;
  let fill = Math.min(L.fmax, L.fill + (PK.stage - 1) * L.df), cars = null;
  const longP = Math.min(L.long1, L.long0 + (PK.stage - 1) * 0.03);
  for (let k = 0; k < 8 && !cars; k++) cars = layout(colsN, rowsN, fill - k * 0.04, longP, Math.min(L.depth + Math.floor(PK.stage / 3), 8), cones);
  if (!cars) cars = [{ c: 0, r: 0, len: 2, ax: 'h' }, { c: 0, r: 2, len: 2, ax: 'v' }];
  const pool = itemPoolP();
  cars.forEach((car, i) => {
    car.o = 0; car.st = 'idle'; car.sh = 0; car.pop = rand(0, 0.35) + (car.r + car.c) * 0.02; car.gone = false;
    if (car.fixed){ car.kind = 'cone'; return; }
    car.face = Math.random() < 0.5 ? -1 : 1;
    car.col = CAR_COLORS[Math.floor(rand(0, CAR_COLORS.length))];
    car.kind = car.len === 2 ? 'sedan' : (Math.random() < 0.55 ? 'truck' : 'bus');
    if (pool.length){ if (!PK.bag.length) PK.bag = shuffleP(pool.slice()); car.h = PK.bag.pop(); }
    car.v = 0;
  });
  // 金の車（2面から1台）：出すと大きな点
  if (PK.stage >= 2){ const two = cars.filter(c => !c.fixed && c.len === 2); if (two.length){ const gc = two[Math.floor(rand(0, two.length))]; gc.gold = true; gc.col = GOLD; } }
  PK.cars = cars;
}
function shuffleP(a){ for (let i = a.length - 1; i > 0; i--){ const j = Math.floor(Math.random() * (i + 1)); [a[i], a[j]] = [a[j], a[i]]; } return a; }
function pLoad(){
  for (const h of PARK_ITEMS){ const it = ITEMS[h]; if (!PK.img[h] && it && it.ok && it.img){ const im = new Image(); im.src = it.img; PK.img[h] = im; } }
}
const itemPoolP = () => PARK_ITEMS.filter(h => ITEMS[h] && ITEMS[h].ok && PK.img[h]);

// ---------- 操作 ----------
const carAt = (x, y) => {
  const g = pGeo(), cx = (x - g.lx) / g.cs, cy = (y - g.ly) / g.cs;
  let best = null;
  for (const c of PK.cars){
    if (c.st === 'exit' || c.gone || c.fixed) continue;
    for (const [mx, my] of carCells(c)) if (cx >= mx - 0.04 && cx < mx + 1.04 && cy >= my - 0.04 && cy < my + 1.04) best = c;
  }
  return best;
};
// 車を走らせる。s は進む向き（-1 は上か左、+1 は下か右）
function drive(car, s){
  if (car.st !== 'idle' || PK.busy > 0 || PK.clearT > 0) return;
  const occ = occOf(PK.cols, PK.rows, PK.cars), ln = lane(occ, PK.cols, PK.rows, PK.cars, car, s);
  if (ln.hit === null){
    const g = pGeo(), p = pCenter(car, g);
    car.st = 'exit'; car.s = s; car.v = 2.5; car.gone = false; PK.exited++; PK.carsTotal = (PK.carsTotal || 0) + 1;
    car.path = exitPath(car, s, g); car.pi = 1; car.px = p.x; car.py = p.y; car.ang = carAngle(car); car.ang0 = car.ang;
    PK.parade.push(car);
    PK.used = PK.used || []; if (car.h && !PK.used.includes(car.h)) PK.used.push(car.h);
    // 連続：前の車を出してから 1.6 秒以内なら「連続」。続くほど点が増え、音も上がる
    PK.chain = PK.t - (PK.lastExit || -9) < 1.6 ? PK.chain + 1 : 1; PK.lastExit = PK.t;
    const gain = 10 + Math.min(PK.combo, 8) * 2 + Math.min(PK.chain - 1, 6) * 5 + (car.gold ? 50 : 0); PK.combo++;
    setScore(score + gain); floatText(p.x, p.y, '+' + gain, car.gold ? C.spark : C.deep); burst(p.x, p.y, car.gold ? C.spark : '#FFFFFF', car.gold ? 22 : 8, 200); sfx('go', PK.chain);
    if (car.gold){ pWord('金の車！ +50', C.spark, true); sfx('gold'); }
    else if (PK.chain >= 2) pWord(PK.chain === 2 ? '連続！' : PK.chain === 3 ? 'ナイス連続！ ×3' : 'すごい！ ×' + PK.chain, C.leaf, PK.chain >= 4);
    if (PK.cars.every(c => c.st === 'exit' || c.gone || c.fixed)){
      const perfect = PK.bumps === 0, bonus = 30 + Math.max(0, 40 - 15 * PK.bumps);
      PK.clearT = 1.15; setScore(score + bonus);
      if (perfect && PK.lives < PK.maxLives){ PK.lives++; }
      setTimeout(() => { if (state === 'play'){ pWord(perfect ? 'ノーミス！ +' + bonus : 'クリア！ +' + bonus, perfect ? C.spark : C.leaf, true); sfx('clear'); for (let i = 0; i < 24; i++) burst(rand(W * 0.1, W * 0.9), rand(H * 0.15, H * 0.5), [C.leaf, C.spark, C.salmon, '#8FD0F0'][i % 4], 2, 200); } }, 260);
    }
  } else {
    car.st = 'bump'; car.s = s; car.ph = 'go'; car.t = 0; car.d = ln.d; car.hit = ln.hit; PK.busy = 0.01;
    car.tg = 0.06 + 0.045 * ln.d; car.tgt = ln.d > 0 ? ln.d : 0.16; sfx('rev');
  }
}
function swipe(dx, dy, tap){
  const car = PK.down && PK.down.car; if (!car) return;
  let s;
  if (tap){   // タップ：前があいていれば前、だめなら後ろ、どちらもだめなら前へ（ぶつかる）
    const fs = car.face, occ = occOf(PK.cols, PK.rows, PK.cars);
    s = lane(occ, PK.cols, PK.rows, PK.cars, car, fs).hit === null ? fs : lane(occ, PK.cols, PK.rows, PK.cars, car, -fs).hit === null ? -fs : fs;
  } else s = (car.ax === 'h' ? dx : dy) >= 0 ? 1 : -1;
  drive(car, s);
}

// ---------- 見た目の大きさ ----------
function pGeo(){
  const cols = PK.cols, rows = PK.rows, topH = 86, botH = 54, road = 0.62;
  const cs = Math.max(20, Math.min((W - 24) / (cols + road * 2), (H - topH - botH) / (rows + road * 2), 96));
  const lx = W / 2 - cols * cs / 2, ly = topH + Math.max(0, (H - topH - botH - (rows + road * 2) * cs) / 2) + road * cs;
  return { cs, lx, ly, road: road * cs, w: cols * cs, h: rows * cs };
}
function pCenter(c, g){
  if (c.path) return { x: c.px, y: c.py };
  const o = c.o + (c.sh > 0 ? Math.sin(c.sh * 55) * 0.09 * Math.min(1, c.sh / 0.2) * (c.shs || 1) : 0);
  return c.ax === 'h' ? { x: g.lx + (c.c + c.len / 2 + o) * g.cs, y: g.ly + (c.r + 0.5) * g.cs } : { x: g.lx + (c.c + 0.5) * g.cs, y: g.ly + (c.r + c.len / 2 + o) * g.cs };
}

const PARKING = {
  id: 'parking', name: '駐車場', unit: '点',
  sub: '車をスワイプして、駐車場から出そう！',
  how: ['車を<b>スワイプ</b>（またはタップ）すると、向いている方向の前か後ろへまっすぐ走る。<b>指を置くと進む道が見える</b>', '道があいていれば出口へ走っていく。車やコーンにぶつかると<b>ハートが減る</b>', '続けて素早く出すと<b>連続ボーナス</b>。光る<b>金の車</b>は大きな点', '全部の車を出せばクリア。ノーミスならハートが1つ戻る'],
  products: PARK_ITEMS,
  levels: [{ id: 'easy', name: 'かんたん' }, { id: 'normal', name: 'ふつう' }, { id: 'hard', name: 'むずかしい' }],
  ranking: true,   // 10/17 依頼者「ランキングも付けて」。サーバーは台数・ステージ・遊んだ時間から点数の上限を確かめる（teraism-worker の casual.js の LIMITS）
  rankExtra(){ return { meters: 0, stage: PK.stage, cars: PK.carsTotal || 0 }; },
  usedProducts(){ return (PK.used || []).slice(0, 6); },
  start(){ pLoad(); PK.carsTotal = 0; PK.parade = []; PK.word = null; PK.lastExit = -9; PK.stage = 0; PK.used = []; PK.combo = 0; PK.maxLives = lvP().lives; PK.lives = PK.maxLives; PK.down = null; newStage(); toast('ステージ 1'); },
  title(){ pLoad(); PK.parade = []; PK.word = null; PK.stage = 0; PK.used = []; PK.combo = 0; PK.maxLives = lvP().lives; PK.lives = PK.maxLives; newStage(); },
  press(e){
    if (!e || e.clientX == null) return;
    PK.down = { x: e.clientX, y: e.clientY, mx: e.clientX, my: e.clientY, car: carAt(e.clientX, e.clientY), fired: false }; PK.hintT = 0;
  },
  release(e){
    const d = PK.down; PK.down = null;
    if (!d || d.fired || !d.car || !e || e.clientX == null) return;
    const dx = e.clientX - d.x, dy = e.clientY - d.y;
    PK.down = d; swipe(dx, dy, Math.hypot(dx, dy) < 14); PK.down = null;
  },
  idle(dt){ PK.t += dt; stepCars(dt, false); },
  update(dt, playing){
    PK.t += dt; stepCars(dt, playing);
    if (PK.word){ PK.word.t += dt; if (PK.word.t > 1) PK.word = null; }
    if (playing && !PK.down && PK.busy <= 0 && PK.clearT <= 0) PK.hintT = (PK.hintT || 0) + dt;   // 手が止まっている時間（ヒント用）
    if (PK.clearT > 0 && playing){ PK.clearT -= dt; if (PK.clearT <= 0){ newStage(); toast('ステージ ' + PK.stage); } }
    $('hudL').textContent = 'ステージ ' + PK.stage;
  },
  draw(){ pDraw(); },
  sfx: {
    go(n){ const b = 79 + Math.min(10, ((n || 1) - 1) * 2); tone(NOTE(b), NOTE(b + 5), 0.09, 'square', 0.04); hiss(0.35, 0.05, 500, 3000, 'bandpass', 1.2); },
    gate(){ tone(NOTE(88), NOTE(91), 0.05, 'triangle', 0.025); },
    gold(){ [76, 79, 84, 88, 91].forEach((n, i) => tone(NOTE(n), NOTE(n), 0.1, 'triangle', 0.045, i * 0.05)); },
    clear(){ [72, 76, 79, 84].forEach((n, i) => tone(NOTE(n), NOTE(n), 0.14, 'square', 0.04, i * 0.08)); },
    rev(){ tone(110, 230, 0.16, 'sawtooth', 0.035); },
    bump(){ tone(150, 55, 0.16, 'square', 0.07); hiss(0.12, 0.08, 3200, 700); },
    honk(){ tone(NOTE(58), NOTE(58), 0.16, 'sawtooth', 0.035); tone(NOTE(62), NOTE(62), 0.16, 'sawtooth', 0.03); },
  },
};
// 動きの更新：ぶつかる車は「行けるところまで進む → ぶつかる → 元の場所へ戻る」、出る車は加速して画面の外へ
function stepCars(dt, playing){
  const g = pGeo();
  for (const c of PK.cars){
    if (c.pop > 0) c.pop -= dt;
    if (c.sh > 0) c.sh = Math.max(0, c.sh - dt);
    if (c.st === 'bump'){
      c.t += dt;
      if (c.ph === 'go'){
        const k = Math.min(1, c.t / c.tg); c.o = c.s * c.tgt * k * k;
        if (k >= 1){
          c.ph = 'back'; c.t = 0;
          if (c.hit){ c.hit.sh = 0.38; c.hit.shs = 1; }
          const p = pCenter(c, g), fx = c.ax === 'h' ? p.x + c.s * g.cs * (c.len / 2 + 0.05) : p.x, fy = c.ax === 'h' ? p.y : p.y + c.s * g.cs * (c.len / 2 + 0.05);
          burst(fx, fy, C.spark, 12, 240); burst(fx, fy, '#FFFFFF', 6, 140); shake(7); sfx('bump'); sfx('honk');
          PK.bumps++; PK.combo = 0; PK.lives = Math.max(0, PK.lives - 1); PK.flash = 0.3;
          floatText(fx, fy - 10, 'ごつん！', C.salmon);
          if (PK.lives <= 0 && playing){ c.over = true; }
        }
      } else {
        const tb = 0.26, k = Math.min(1, c.t / tb), e = 1 - Math.pow(1 - k, 3);
        c.o = c.s * c.tgt * (1 - e) - c.s * 0.1 * Math.sin(k * Math.PI) * (k > 0.55 ? 0 : 1);
        if (k >= 1){
          c.o = 0; c.st = 'idle'; PK.busy = 0;
          if (c.over && playing){ c.over = false; gameOver('ハートがなくなった　ステージ ' + PK.stage + '・' + (PK.carsTotal || 0) + '台出した'); }
        }
      }
      if (c.st === 'bump') PK.busy = 0.01;
    }
  }
  // パレード：駐車場から出た車は、まわりの道路を走って下の出口から出ていく
  for (let i = PK.parade.length - 1; i >= 0; i--){
    const c = PK.parade[i];
    c.v = Math.min(15, c.v + 40 * dt);
    let step = c.v * g.cs * dt;
    while (step > 0 && c.pi < c.path.length){
      const [tx, ty] = c.path[c.pi], dx = tx - c.px, dy = ty - c.py, d = Math.hypot(dx, dy);
      if (c.pi >= 2 && d > 0.01){ const want = Math.atan2(dx, -dy); let da = want - c.ang; while (da > Math.PI) da -= TAU; while (da < -Math.PI) da += TAU; c.ang += da * Math.min(1, dt * 14); }
      if (d <= step){ c.px = tx; c.py = ty; step -= d; c.pi++; if (c.pi === c.path.length - 1){ burst(tx, ty, C.spark, 6, 140); sfx('gate'); } }
      else { c.px += dx / d * step; c.py += dy / d * step; step = 0; }
    }
    if (Math.random() < dt * 12) burst(c.px - Math.sin(c.ang) * g.cs * c.len * 0.45, c.py + Math.cos(c.ang) * g.cs * c.len * 0.45, '#FFFFFF', 1, 50);
    if (c.pi >= c.path.length){ c.gone = true; PK.parade.splice(i, 1); }
  }
  PK.flash = Math.max(0, PK.flash - dt);
}

// ---------- 描く ----------
function pDraw(){
  const g = pGeo(), { cs, lx, ly } = g, rd = g.road;
  // 道路（駐車場のまわり）と駐車場の地面
  ctx.fillStyle = 'rgba(21,122,68,.12)'; rr(lx - rd + 3, ly - rd + 7, g.w + rd * 2, g.h + rd * 2, cs * 0.5); ctx.fill();
  ctx.fillStyle = '#C3D1C8'; rr(lx - rd, ly - rd, g.w + rd * 2, g.h + rd * 2, cs * 0.5); ctx.fill();
  ctx.setLineDash([cs * 0.28, cs * 0.24]); ctx.strokeStyle = '#FFF4CF'; ctx.lineWidth = Math.max(2, cs * 0.045);
  rr(lx - rd / 2, ly - rd / 2, g.w + rd, g.h + rd, cs * 0.3); ctx.stroke(); ctx.setLineDash([]);
  ctx.fillStyle = '#D6E2DA'; rr(lx - 3, ly - 3, g.w + 6, g.h + 6, cs * 0.14); ctx.fill();
  ctx.strokeStyle = 'rgba(255,255,255,.85)'; ctx.lineWidth = Math.max(1.5, cs * 0.04);
  ctx.beginPath();
  for (let i = 0; i <= PK.cols; i++){ ctx.moveTo(lx + i * cs, ly); ctx.lineTo(lx + i * cs, ly + g.h); }
  for (let j = 0; j <= PK.rows; j++){ ctx.moveTo(lx, ly + j * cs); ctx.lineTo(lx + g.w, ly + j * cs); }
  ctx.stroke();
  // 車（上の行から順に重ねる。出ていく車は最後）
  pDrawGate(g);
  pDrawPreview(g);
  const order = PK.cars.filter(c => !c.gone && c.st !== 'exit').sort((a, b) => (a.r + (a.ax === 'v' ? a.len : 1)) - (b.r + (b.ax === 'v' ? b.len : 1)));
  for (const c of order) c.fixed ? pCone(c, g) : pCar(c, g);
  pDrawHint(g);
  pDrawPicked(g);
  // 下の表示：ハートとのこり台数
  const left = PK.cars.filter(c => c.st !== 'exit' && !c.gone && !c.fixed).length;
  const by = Math.min(H - 26, ly + g.h + rd + 34);
  // 出口から下へのびる道をはさんで、左に「のこり」、右にハート
  ctx.textAlign = 'right'; ctx.font = "900 15px 'Zen Maru Gothic', sans-serif";
  ctx.fillStyle = C.deep; ctx.fillText('のこり ' + left + ' 台', W / 2 - rd / 2 - 12, by + 5); ctx.textAlign = 'center';
  const hs = 11, hx0 = W / 2 + rd / 2 + 8;
  for (let i = 0; i < PK.maxLives; i++){
    const full = i < PK.lives, pulse = full || !PK.flash ? 1 : 1 + PK.flash * 0.6;
    pHeart(hx0 + i * (hs * 2.5) + hs, by, hs * pulse, full ? C.salmon : '#FFFFFF', full ? '#D9604C' : '#C6D6CC');
  }
  for (const c of PK.parade) pCar(c, g);   // 出ていく車はいちばん上に
  if (PK.flash > 0){ ctx.fillStyle = 'rgba(240,127,107,' + (PK.flash * 0.35) + ')'; ctx.fillRect(-20, -20, W + 40, H + 40); }
  if (PK.word){
    const w = PK.word, t = w.t, sc = t < 0.12 ? 0.5 + t / 0.12 * 0.7 : 1.2 - Math.min(0.2, (t - 0.12) * 0.8), a = clamp((1 - t) / 0.3, 0, 1);
    ctx.save(); ctx.globalAlpha = a; ctx.translate(W / 2, ly + g.h * 0.45 - t * 20);   // 駐車場の真ん中（上の「ステージ N」の知らせと重ねない） ctx.scale(sc, sc);
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.lineJoin = 'round';
    ctx.font = `400 ${Math.round(Math.min(W * (w.big ? 0.095 : 0.075), w.big ? 40 : 32))}px 'Dela Gothic One', sans-serif`;
    ctx.lineWidth = 8; ctx.strokeStyle = '#FFFFFF'; ctx.strokeText(w.s, 0, 0); ctx.fillStyle = w.col; ctx.fillText(w.s, 0, 0);
    ctx.textBaseline = 'alphabetic'; ctx.restore();
  }
}
// 大きい声かけ（連続・金の車・クリア）。新しいものが来たら入れ替える
function pWord(s, col, big){ PK.word = { s, col, big: !!big, t: 0 }; }
// 車の向き（前が上＝0）。描くときと、パレードの始まりに使う
const carAngle = (c) => c.ax === 'h' ? (c.face > 0 ? Math.PI / 2 : -Math.PI / 2) : (c.face > 0 ? Math.PI : 0);
// 道路の真ん中の線（駐車場をぐるっと囲む四角）
const ringOf = (g) => ({ x0: g.lx - g.road / 2, y0: g.ly - g.road / 2, x1: g.lx + g.w + g.road / 2, y1: g.ly + g.h + g.road / 2 });
// 出ていく道すじ：①向いた方へまっすぐ道路まで ②道路を近い回り方で出口（下の道路の真ん中）まで ③画面の下へ
function exitPath(car, s, g){
  const R = ringOf(g), p0 = pCenter(car, g), wx = R.x1 - R.x0, hy = R.y1 - R.y0, P = 2 * (wx + hy);
  const p1 = car.ax === 'h' ? [s > 0 ? R.x1 : R.x0, p0.y] : [p0.x, s > 0 ? R.y1 : R.y0];
  const E = [W / 2, R.y1];
  const md = (v) => ((v % P) + P) % P;
  // 道路の上の位置を、左上から時計回りの長さで表す
  const per = ([x, y]) => Math.abs(y - R.y0) < 0.5 ? x - R.x0 : Math.abs(x - R.x1) < 0.5 ? wx + (y - R.y0) : Math.abs(y - R.y1) < 0.5 ? wx + hy + (R.x1 - x) : 2 * wx + hy + (R.y1 - y);
  const corners = [[0, [R.x0, R.y0]], [wx, [R.x1, R.y0]], [wx + hy, [R.x1, R.y1]], [2 * wx + hy, [R.x0, R.y1]]];
  const t1 = per(p1), t2 = per(E), cw = md(t2 - t1), ccw = P - cw, go = cw <= ccw;
  const dist = (t) => go ? md(t - t1) : md(t1 - t);
  const lim = go ? cw : ccw;
  const list = corners.filter(([t]) => dist(t) > 0 && dist(t) < lim).sort((a, b) => dist(a[0]) - dist(b[0]));
  const pts = [[p0.x, p0.y], p1];
  for (const [, q] of list) pts.push(q);
  pts.push(E, [E[0], H + g.cs * 3]);
  return pts;
}
// 出口のゲート：下の道路の真ん中。出ていく車が近いとバーが上がる
function pDrawGate(g){
  const R = ringOf(g), x = W / 2, y = R.y1, cs = g.cs;
  const near = PK.parade.some(c => Math.hypot(c.px - x, c.py - y) < cs * 2.2);
  PK.bar = (PK.bar || 0) + ((near ? 1 : 0) - (PK.bar || 0)) * 0.25;
  ctx.fillStyle = '#C3D1C8'; ctx.fillRect(x - g.road / 2, y, g.road, H - y + 10);   // 出口から下へのびる道
  ctx.strokeStyle = '#FFF4CF'; ctx.lineWidth = Math.max(2, cs * 0.045); ctx.setLineDash([cs * 0.28, cs * 0.24]); ctx.beginPath(); ctx.moveTo(x, y + g.road / 2); ctx.lineTo(x, H + 10); ctx.stroke(); ctx.setLineDash([]);
  const bx = x + g.road / 2 + cs * 0.12, by = y + g.road * 0.55;
  ctx.fillStyle = C.deep; rr(bx - cs * 0.12, by - cs * 0.3, cs * 0.24, cs * 0.42, 2); ctx.fill();   // ゲートの柱
  ctx.save(); ctx.translate(bx, by - cs * 0.2); ctx.rotate(Math.PI / 2 * 0.9 * PK.bar);
  const bl = g.road + cs * 0.1; for (let i = 0; i < 6; i++){ ctx.fillStyle = i % 2 ? '#FFFFFF' : C.salmon; ctx.fillRect(-bl + i * bl / 6, -cs * 0.05, bl / 6 + 0.5, cs * 0.1); }
  ctx.restore();
}
// 指を置いた車の進む道：行ける向きは緑の帯と矢印、ぶつかる向きは赤い帯とぶつかる相手の印。指をずらすと、その向きだけを出す
function pDrawPreview(g){
  const d = PK.down, c = d && d.car; if (!c || c.st !== 'idle' || state !== 'play') return;
  const occ = occOf(PK.cols, PK.rows, PK.cars), dd = c.ax === 'h' ? d.mx - d.x : d.my - d.y, only = Math.abs(dd) > 14 ? (dd > 0 ? 1 : -1) : 0;
  for (const s of [-1, 1]){
    if (only && s !== only) continue;
    const ln = lane(occ, PK.cols, PK.rows, PK.cars, c, s), free = ln.hit === null;
    const n = free ? ln.d + 0.62 : ln.d, a = s > 0 ? (c.ax === 'h' ? c.c + c.len : c.r + c.len) : (c.ax === 'h' ? c.c : c.r);
    const from = s > 0 ? a : a - n, cs = g.cs;
    ctx.fillStyle = free ? 'rgba(31,163,92,.28)' : 'rgba(240,127,107,.3)';
    if (n > 0){ if (c.ax === 'h') ctx.fillRect(g.lx + from * cs, g.ly + (c.r + 0.2) * cs, n * cs, cs * 0.6); else ctx.fillRect(g.lx + (c.c + 0.2) * cs, g.ly + from * cs, cs * 0.6, n * cs); }
    const tip = s > 0 ? a + n : a - n, tx = c.ax === 'h' ? g.lx + tip * cs : g.lx + (c.c + 0.5) * cs, ty = c.ax === 'h' ? g.ly + (c.r + 0.5) * cs : g.ly + tip * cs;
    if (free){   // 矢印
      ctx.save(); ctx.translate(tx, ty); ctx.rotate(c.ax === 'h' ? (s > 0 ? 0 : Math.PI) : (s > 0 ? Math.PI / 2 : -Math.PI / 2));
      ctx.fillStyle = C.leaf; ctx.beginPath(); ctx.moveTo(cs * 0.05, 0); ctx.lineTo(-cs * 0.3, -cs * 0.26); ctx.lineTo(-cs * 0.3, cs * 0.26); ctx.closePath(); ctx.fill(); ctx.restore();
    } else {     // ぶつかる相手を赤い点線の枠で
      const h = ln.hit, x0 = g.lx + h.c * cs, y0 = g.ly + h.r * cs, w = (h.ax === 'h' ? h.len : 1) * cs, hh = (h.ax === 'v' ? h.len : 1) * cs;
      ctx.strokeStyle = C.salmon; ctx.lineWidth = 3; ctx.setLineDash([6, 4]); ctx.strokeRect(x0 + 2, y0 + 2, w - 4, hh - 4); ctx.setLineDash([]);
    }
  }
}
// ヒント：5秒手が止まっていたら、出せる車のまわりがふわっと光る
function pDrawHint(g){
  if (state !== 'play' || (PK.hintT || 0) < 5 || PK.clearT > 0) return;
  const occ = occOf(PK.cols, PK.rows, PK.cars);
  const c = PK.cars.find(c => !c.fixed && c.st === 'idle' && (lane(occ, PK.cols, PK.rows, PK.cars, c, 1).hit === null || lane(occ, PK.cols, PK.rows, PK.cars, c, -1).hit === null));
  if (!c) return;
  const cs = g.cs, x0 = g.lx + c.c * cs, y0 = g.ly + c.r * cs, w = (c.ax === 'h' ? c.len : 1) * cs, h = (c.ax === 'v' ? c.len : 1) * cs, a = 0.35 + 0.35 * Math.sin(PK.t * 5);
  ctx.strokeStyle = `rgba(244,180,0,${0.45 + a})`; ctx.lineWidth = 4 + 2 * Math.sin(PK.t * 5); rr(x0 + 1, y0 + 1, w - 2, h - 2, cs * 0.2); ctx.stroke();
}
// 指を置いている車：白い枠で囲む
function pDrawPicked(g){
  const d = PK.down, c = d && d.car; if (!c || c.st !== 'idle' || state !== 'play') return;
  const cs = g.cs, x0 = g.lx + c.c * cs, y0 = g.ly + c.r * cs, w = (c.ax === 'h' ? c.len : 1) * cs, h = (c.ax === 'v' ? c.len : 1) * cs;
  ctx.strokeStyle = '#FFFFFF'; ctx.lineWidth = 5; rr(x0 + 2, y0 + 2, w - 4, h - 4, cs * 0.2); ctx.stroke();
  ctx.strokeStyle = C.deep; ctx.lineWidth = 2; rr(x0 + 2, y0 + 2, w - 4, h - 4, cs * 0.2); ctx.stroke();
}
// コーン（動かない障害物）：真上から見たパイロン
function pCone(c, g){
  const cs = g.cs, p = pCenter(c, g); let sc = 1;
  if (c.pop > 0){ const k = 1 - Math.max(0, c.pop) / PIN; sc = k <= 0 ? 0 : 0.4 + 0.6 * Math.min(1, k); }
  if (sc <= 0.01) return;
  const o = c.sh > 0 ? Math.sin(c.sh * 55) * cs * 0.05 : 0;
  ctx.save(); ctx.translate(p.x + o, p.y); ctx.scale(sc, sc);
  ctx.fillStyle = 'rgba(21,122,68,.2)'; ctx.beginPath(); ctx.ellipse(cs * 0.05, cs * 0.12, cs * 0.34, cs * 0.24, 0, 0, TAU); ctx.fill();
  ctx.fillStyle = '#F4A35C'; rr(-cs * 0.32, -cs * 0.32, cs * 0.64, cs * 0.64, cs * 0.08); ctx.fill();   // 台
  ctx.fillStyle = '#F07F6B'; ctx.beginPath(); ctx.arc(0, 0, cs * 0.24, 0, TAU); ctx.fill();
  ctx.strokeStyle = '#FFFFFF'; ctx.lineWidth = cs * 0.07; ctx.beginPath(); ctx.arc(0, 0, cs * 0.15, 0, TAU); ctx.stroke();
  ctx.fillStyle = '#FFE0D0'; ctx.beginPath(); ctx.arc(0, 0, cs * 0.06, 0, TAU); ctx.fill();
  ctx.restore();
}
function pHeart(x, y, r, fill, line){
  ctx.beginPath(); ctx.moveTo(x, y + r * 0.9);
  ctx.bezierCurveTo(x - r * 1.5, y - r * 0.1, x - r * 0.9, y - r * 1.15, x, y - r * 0.4);
  ctx.bezierCurveTo(x + r * 0.9, y - r * 1.15, x + r * 1.5, y - r * 0.1, x, y + r * 0.9);
  ctx.fillStyle = fill; ctx.fill(); ctx.strokeStyle = line; ctx.lineWidth = 2; ctx.stroke();
}
function pCar(c, g){
  const cs = g.cs, p = pCenter(c, g);
  const angle = c.path ? c.ang : carAngle(c);
  const L = c.len * cs - cs * 0.16, Wd = cs * 0.74;
  let sc = 1;
  if (c.pop > 0){ const k = 1 - Math.max(0, c.pop) / PIN; sc = k <= 0 ? 0 : 0.4 + 0.6 * Math.min(1, k) + Math.sin(Math.min(1, k) * Math.PI) * 0.14; }
  if (sc <= 0.01) return;
  const exiting = c.st === 'exit', lift = exiting ? cs * 0.1 : (c.st === 'bump' ? cs * 0.05 : 0);
  if (c.gold){ ctx.fillStyle = `rgba(244,180,0,${0.25 + 0.15 * Math.sin(PK.t * 4)})`; ctx.beginPath(); ctx.ellipse(p.x, p.y - lift, (c.ax === 'h' ? L : Wd) * 0.75, (c.ax === 'h' ? Wd : L) * 0.75, 0, 0, TAU); ctx.fill(); }
  // 影
  ctx.save(); ctx.translate(p.x + cs * 0.06, p.y + cs * 0.1 + lift); ctx.rotate(angle); ctx.scale(sc, sc);
  ctx.fillStyle = 'rgba(21,122,68,.2)'; rr(-Wd / 2, -L / 2, Wd, L, Wd * 0.4); ctx.fill(); ctx.restore();
  // 厚み（少し斜め上から見たように、下側に濃い色をのぞかせる）
  const th = cs * 0.09;
  ctx.save(); ctx.translate(p.x, p.y - lift + th); ctx.rotate(angle); ctx.scale(sc, sc);
  ctx.fillStyle = c.col.dark; rr(-Wd / 2, -L / 2, Wd, L, Wd * 0.4); ctx.fill(); ctx.restore();
  ctx.save(); ctx.translate(p.x, p.y - lift); ctx.rotate(angle); ctx.scale(sc, sc);
  carBody(c, Wd, L);
  ctx.restore();
  if (c.gold){   // 金の車：まわりに白い星がきらめく
    for (let i = 0; i < 3; i++){
      const a = PK.t * 2 + i * 2.1, r = cs * (0.35 + 0.15 * Math.sin(PK.t * 3 + i)), sx = p.x + Math.cos(a) * r * c.len * 0.7, sy = p.y - lift + Math.sin(a) * r;
      ctx.fillStyle = `rgba(255,255,255,${0.6 + 0.4 * Math.sin(PK.t * 6 + i)})`;
      ctx.beginPath(); ctx.moveTo(sx, sy - 5); ctx.lineTo(sx + 1.6, sy - 1.6); ctx.lineTo(sx + 5, sy); ctx.lineTo(sx + 1.6, sy + 1.6); ctx.lineTo(sx, sy + 5); ctx.lineTo(sx - 1.6, sy + 1.6); ctx.lineTo(sx - 5, sy); ctx.lineTo(sx - 1.6, sy - 1.6); ctx.closePath(); ctx.fill();
    }
  }
  // 商品（実物の写真を丸く切り抜いて屋根・荷台に載せる。写真は向きを回さない）
  const im = c.h && PK.img[c.h];
  if (im && im.complete && im.width){
    const off = c.kind === 'truck' ? L * 0.2 : c.kind === 'bus' ? L * 0.02 : L * 0.06;
    const q = { x: p.x - Math.sin(angle) * off, y: p.y - lift + Math.cos(angle) * off };
    const r = (c.kind === 'sedan' ? Wd * 0.3 : Wd * 0.34) * sc, cx = q.x, cy = q.y - cs * 0.04;
    ctx.fillStyle = 'rgba(21,122,68,.22)'; ctx.beginPath(); ctx.ellipse(cx + 1.5, cy + r * 0.34 + 2, r * 1.0, r * 0.82, 0, 0, TAU); ctx.fill();
    ctx.fillStyle = '#FFFFFF'; ctx.beginPath(); ctx.arc(cx, cy, r * 1.1, 0, TAU); ctx.fill();
    ctx.save(); ctx.beginPath(); ctx.arc(cx, cy, r, 0, TAU); ctx.clip();
    const sw = im.width / 1.7; ctx.drawImage(im, im.width / 2 - sw / 2, im.height * 0.42 - sw / 2, sw, sw, cx - r, cy - r, r * 2, r * 2);
    ctx.restore();
  }
}
// 車体（前が上向き。原点が車の真ん中）：普通車・軽トラ・バス
function carBody(c, Wd, L){
  const k = c.col, hw = Wd / 2, hl = L / 2, glass = '#D4F0FF', lw = Math.max(1.2, Wd * 0.05);
  // タイヤ（車体からちらっと見える）
  ctx.fillStyle = '#8CA397';
  const ty = c.len === 2 ? [-L * 0.27, L * 0.27] : [-L * 0.3, L * 0.3];
  for (const y of ty) for (const sx of [-1, 1]){ rr(sx * hw - Wd * 0.07, y - Wd * 0.16, Wd * 0.14, Wd * 0.32, Wd * 0.05); ctx.fill(); }
  // 車体
  ctx.fillStyle = k.main; ctx.strokeStyle = k.dark; ctx.lineWidth = lw;
  rr(-hw, -hl, Wd, L, Wd * 0.4); ctx.fill(); ctx.stroke();
  ctx.fillStyle = 'rgba(255,255,255,.35)'; rr(-hw * 0.78, -hl * 0.96, Wd * 0.18, L * 0.5, Wd * 0.08); ctx.fill();   // つや
  if (c.kind === 'sedan'){
    ctx.fillStyle = glass; ctx.beginPath(); ctx.moveTo(-hw * 0.74, -L * 0.2); ctx.lineTo(hw * 0.74, -L * 0.2); ctx.lineTo(hw * 0.84, -L * 0.08); ctx.lineTo(-hw * 0.84, -L * 0.08); ctx.closePath(); ctx.fill();
    ctx.fillStyle = k.light; ctx.strokeStyle = k.dark; rr(-hw * 0.82, -L * 0.08, Wd * 0.82, L * 0.34, Wd * 0.14); ctx.fill(); ctx.stroke();
    ctx.fillStyle = glass; rr(-hw * 0.6, L * 0.27, Wd * 0.6, L * 0.07, Wd * 0.03); ctx.fill();
  } else if (c.kind === 'truck'){
    ctx.fillStyle = glass; ctx.beginPath(); ctx.moveTo(-hw * 0.74, -L * 0.3); ctx.lineTo(hw * 0.74, -L * 0.3); ctx.lineTo(hw * 0.84, -L * 0.2); ctx.lineTo(-hw * 0.84, -L * 0.2); ctx.closePath(); ctx.fill();
    ctx.fillStyle = k.light; ctx.strokeStyle = k.dark; rr(-hw * 0.82, -L * 0.2, Wd * 0.82, L * 0.17, Wd * 0.1); ctx.fill(); ctx.stroke();
    ctx.fillStyle = '#F6EFD6'; rr(-hw * 0.92, -L * 0.0, Wd * 0.92, L * 0.47, Wd * 0.08); ctx.fill(); ctx.stroke();   // 荷台
    ctx.fillStyle = '#FFFBEC'; rr(-hw * 0.72, L * 0.04, Wd * 0.72, L * 0.39, Wd * 0.05); ctx.fill();
  } else {
    ctx.fillStyle = glass; ctx.beginPath(); ctx.moveTo(-hw * 0.78, -L * 0.36); ctx.lineTo(hw * 0.78, -L * 0.36); ctx.lineTo(hw * 0.86, -L * 0.25); ctx.lineTo(-hw * 0.86, -L * 0.25); ctx.closePath(); ctx.fill();
    ctx.fillStyle = k.light; ctx.strokeStyle = k.dark; rr(-hw * 0.84, -L * 0.25, Wd * 0.84, L * 0.64, Wd * 0.14); ctx.fill(); ctx.stroke();
    ctx.fillStyle = k.main; for (const y of [-0.15, 0.3]){ rr(-hw * 0.5, L * y - L * 0.02, Wd * 0.5, L * 0.04, Wd * 0.02); ctx.fill(); }
    ctx.fillStyle = glass; rr(-hw * 0.6, L * 0.4, Wd * 0.6, L * 0.05, Wd * 0.03); ctx.fill();
  }
  // ミラー・ライト
  ctx.fillStyle = k.dark; for (const sx of [-1, 1]){ ctx.beginPath(); ctx.ellipse(sx * (hw + Wd * 0.03), -L * (c.len === 2 ? 0.2 : 0.3), Wd * 0.07, Wd * 0.1, 0, 0, TAU); ctx.fill(); }
  ctx.fillStyle = '#FFF3B0'; ctx.strokeStyle = '#F4B400'; ctx.lineWidth = 1;
  for (const sx of [-1, 1]){ ctx.beginPath(); ctx.ellipse(sx * hw * 0.55, -hl + Wd * 0.13, Wd * 0.12, Wd * 0.075, 0, 0, TAU); ctx.fill(); ctx.stroke(); }
  ctx.fillStyle = '#F07F6B';
  for (const sx of [-1, 1]){ rr(sx * hw * 0.55 - Wd * 0.1, hl - Wd * 0.17, Wd * 0.2, Wd * 0.09, Wd * 0.03); ctx.fill(); }
}

addEventListener('pointermove', (e) => { if (PK.down){ PK.down.mx = e.clientX; PK.down.my = e.clientY; } });
boot(PARKING);
